import { SearchFilter, Accommodation, Value } from "./utils";
import { VirtualSelectorStore } from "../base/VirtualSelectorStore";

export class AccommodationSelectorStore extends VirtualSelectorStore<
  SearchFilter,
  Accommodation,
  Value
> {}
